import ViewWaitingList from "../components/wait-list/ViewWaitList";

export default function WaitingListPage() {
  return <ViewWaitingList />;
}
